import React from "react";
import { BrowserRouter} from "react-router-dom";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/index.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { ModalProvider } from "./utils/modalContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <ModalProvider>
        <App />
      </ModalProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
